import React, { useEffect, useRef } from 'react';
import classnames from "classnames";
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Card } from "../Card";
import './CardsSlider.scss';

SwiperCore.use([Navigation]);

const sliderSettings = {
  slidesPerView: 1,
  slidesPerGroup: 1,
  navigation: true,
  watchSlidesProgress: true,
  breakpoints: {
    480: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 10
    },
    768: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 10
    },
    1024: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      spaceBetween: 10
    },
    1400: {
      slidesPerView: 5,
      slidesPerGroup: 5,
      spaceBetween: 10
    },
    1920: {
      slidesPerView: 5,
      slidesPerGroup: 5,
      spaceBetween: 20
    }
  }
};

export function CardsSlider({
  isShowDate,
  isShowWatchLater,
  addPopupSeriesSearchParam,
  type,
  className,
  cards,
  limit,
  onToggleWatchLater,
  onSeeAll,
  title
}) {
  const slider = useRef();

  function handleResize() {
    const sliderEl = slider.current;
    const arrowsEl = sliderEl.querySelectorAll('.swiper-button-prev, .swiper-button-next');
    const cardImage = sliderEl.querySelector('.Card__image-block');
    const cardImageHeight = cardImage?.clientHeight;

    arrowsEl.forEach((arrow) => {
      arrow.style.height = `${cardImageHeight}px`;
    });
  }

  useEffect(() => {
    handleResize();

    const sliderEl = slider.current;
    const arrowLeftEl = sliderEl?.querySelector('.swiper-button-prev');
    const arrowRightEl = sliderEl?.querySelector('.swiper-button-next');

    arrowLeftEl?.addEventListener('click', sendPrevBtnClickToAnalytics);
    arrowRightEl?.addEventListener('click', sendNextBtnClickToAnalytics);

    return () => {
      arrowLeftEl?.removeEventListener('click', sendPrevBtnClickToAnalytics);
      arrowRightEl?.removeEventListener('click', sendNextBtnClickToAnalytics);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sendPrevBtnClickToAnalytics = () => {
    // actid=9
    window.analytics?.track("button:click", {
      "button_name": "swiper-button-prev",
      "parent_object_title": title,
      "url": window.location.href
    });
  }
  const sendNextBtnClickToAnalytics = () => {
    // actid=9
    window.analytics?.track("button:click", {
      "button_name": "swiper-button-next",
      "parent_object_title": title,
      "url": window.location.href
    });
  }

  const cardSlides = limit ? cards.slice(0, limit) : cards;
  const isExcess = limit ? cardSlides.length > limit : false;

  const sendCardClickToAnalytics = (card) => {
    // actid=10
    window.analytics?.track("object:click", {
      "object": type,
      "parent_object_title": title,
      "title": card.title,
      "url": card.url
    });
  }

  return (
    <Swiper
      {...sliderSettings}
      ref={slider}
      className={classnames('CardsSlider', className)}
      onResize={handleResize}
    >
      {cardSlides.map((card) => (
        <SwiperSlide key={card.id}>
          <Card
            parentObjectTitle={title}
            isShowDate={isShowDate}
            isShowWatchLater={isShowWatchLater}
            addPopupSeriesSearchParam={addPopupSeriesSearchParam}
            type={type}
            cardItem={card}
            className="CardsSlider__card"
            onToggleWatchLater={onToggleWatchLater}
            onClick={() => sendCardClickToAnalytics(card)}
          />
        </SwiperSlide>
      ))}

      {isExcess && onSeeAll && (
        <SwiperSlide>
          <div className="CardsSlider__seeAllSlide">
            <div className="CardsSlider__seeAllSlide-inner">
              <button
                className="CardsSlider__seeAll"
                type="button"
                onClick={onSeeAll}
              >
                view all
              </button>
            </div>
          </div>
        </SwiperSlide>
      )}
    </Swiper>
  );
}
